/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { Button } from "components/ui/Button";
import Heading from "components/ui/Heading";
import { Input, PasswordInput } from "components/ui/Input";
import Label from "components/ui/Label";
import Stack from "components/ui/Stack";
import Text from "components/ui/Text";

import verifyOnlyEnglish from "utils/verifyOnlyEnglish";

const AdminCredentials = ({
  username,
  setUsername,
  password,
  setPassword,
  isPasswordEnabled,
  setPasswordEnabled,
  formPermissions,
}) => {
  return (
    <Stack className="" test-id="NOtxiaA9">
      <Heading as="h3" className="mb-3" test-id="PzQKVUU-">
        Credentials
      </Heading>

      <Stack
        className={cn(
          "bg-secondary-accent py-8 px-8 lg:px-10 h-80",
          formPermissions.isEditing
            ? " space-y-2 justify-between"
            : "space-y-0 justify-around",
        )}
        test-id="b3bYUZ6Y"
      >
        <Stack test-id="YBlM3YYX">
          <Label size="large" htmlFor="username" isRequired test-id="qc0BAWNE">
            Username
          </Label>

          <Input
            id="username"
            value={username}
            name="username"
            disabled={formPermissions.isDisabled}
            placeholder="John Doe"
            onChange={({ target: { value } }) =>
              setUsername(verifyOnlyEnglish(value))
            }
            test-id="3xSsHACd"
          />
        </Stack>

        <div
          className={cn(
            formPermissions.isCreating || isPasswordEnabled ? "flex" : "hidden",
          )}
          test-id="jfAxY41-"
        >
          <PasswordInput
            password={password}
            onChange={setPassword}
            disabled={formPermissions.isDisabled}
            test-id="LhOE00KM"
          />
        </div>

        {formPermissions.isEditing && (
          <Stack test-id="skkJ9jik">
            <Label
              htmlFor="password_toggle"
              size="large"
              className={cn(isPasswordEnabled && "hidden")}
              test-id="psEyVB4O"
            >
              Forgot password?
            </Label>

            <div test-id="AjK1hBVP">
              <Button
                id="password_toggle"
                size="large"
                variant="primary-outline"
                disabled={formPermissions.isDisabled}
                onClick={() => setPasswordEnabled((prev) => !prev)}
                test-id="bxp2Jk7O"
              >
                <Text
                  as="span"
                  className="font-semibold text-base"
                  test-id="yLBuAW6O"
                >
                  {isPasswordEnabled ? "Cancel" : "Create New password"}
                </Text>
              </Button>
            </div>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default AdminCredentials;
